import { render, staticRenderFns } from "./comment-display.vue?vue&type=template&id=f2b92cbe&scoped=true&"
import script from "./comment-display.vue?vue&type=script&lang=js&"
export * from "./comment-display.vue?vue&type=script&lang=js&"
import style0 from "./comment-display.vue?vue&type=style&index=0&id=f2b92cbe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b92cbe",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b92cbe')) {
      api.createRecord('f2b92cbe', component.options)
    } else {
      api.reload('f2b92cbe', component.options)
    }
    module.hot.accept("./comment-display.vue?vue&type=template&id=f2b92cbe&scoped=true&", function () {
      api.rerender('f2b92cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/portfolio-review/components/comment-display/comment-display.vue"
export default component.exports